import {
  PrivacyTip,
  ReceiptLongOutlined,
  Settings,
  SupportAgentOutlined,
} from '@mui/icons-material';
import { useState } from 'react';

import {
  StyledNeedAssistanceContentButton,
  StyledNeedAssistanceContentButtons,
} from 'components/DeepSearch/components/AccountPage/sections/NeedAssistance/components';
import { SubscriptionSettingsPopover } from 'components/DeepSearch/components/AccountPage/sections/NeedAssistance/SubscriptionSettingsModal';

interface ActionButtonsProps {
  onSupportClick: () => void;
  onBillingClick: () => void;
  onPrivacyClick: () => void;
  onUpgradePlanClick?: () => void;
}

export const ActionButtons = ({
  onSupportClick,
  onBillingClick,
  onPrivacyClick,
  onUpgradePlanClick,
}: ActionButtonsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const popoverOpened = Boolean(anchorEl);
  const id = popoverOpened ? 'simple-popover' : undefined;

  const handleSubscriptionSettingsClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <StyledNeedAssistanceContentButtons>
      <StyledNeedAssistanceContentButton
        variant="outlined"
        size="medium"
        startIcon={<SupportAgentOutlined />}
        onClick={onSupportClick}
      >
        Support
      </StyledNeedAssistanceContentButton>
      <StyledNeedAssistanceContentButton
        variant="outlined"
        size="medium"
        startIcon={<ReceiptLongOutlined />}
        onClick={onBillingClick}
      >
        Billing
      </StyledNeedAssistanceContentButton>
      <StyledNeedAssistanceContentButton
        variant="outlined"
        size="medium"
        startIcon={<PrivacyTip />}
        onClick={onPrivacyClick}
      >
        Privacy
      </StyledNeedAssistanceContentButton>
      <StyledNeedAssistanceContentButton
        variant="outlined"
        size="medium"
        startIcon={<Settings />}
        onClick={handleSubscriptionSettingsClick}
      >
        Subscription Settings
      </StyledNeedAssistanceContentButton>
      <SubscriptionSettingsPopover
        open={popoverOpened}
        id={id}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onUpgradePlanClick={onUpgradePlanClick}
      />
    </StyledNeedAssistanceContentButtons>
  );
};
